const ReportFilterBanner = ({ filters = {}, onClear }) => {
  if (Object.keys(filters).length === 0) return null;

  const formatLabel = (key) => {
    const words = key.replace(/_/g, " ").split(" ");
    return words
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(" ");
  };

  const groups = {
    Roles: ["lob", "manager", "team_lead", "agent"],
    DCA: ["dca_organization", "dca_manager", "dca_team", "dca_agent"],
    Time: ["time_period", "from_date", "to_date"],
    Campaign: [
      "campaign_name",
      "collection_strategy",
      "product_type",
      "bucket_type",
    ],
  };

  return (
    <div
      style={{
        margin: "0 16px 10px",
        padding: "8px 16px",
        backgroundColor: "#e8e3fa",
        borderLeft: "4px solid #271078",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        flexWrap: "wrap",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {/* Tags */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontSize: "12px",
              fontWeight: "700",
              color: "#271078",
              marginRight: "4px",
            }}
          >
            Filters ({Object.keys(filters).length}):
          </span>
          {Object.entries(groups).map(([groupName, keys]) => {
            const activeInGroup = keys.filter((k) => filters[k]);
            if (activeInGroup.length === 0) return null;
            return (
              <div
                key={groupName}
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#f2effa",
                  border: "1px solid #dcd4f5",
                  borderRadius: "20px",
                  padding: "4px 6px 4px 16px",
                  color: "#271078",
                  fontSize: "13px",
                  fontWeight: "600",
                  gap: "8px",
                }}
              >
                <span>{groupName}</span>
                <div style={{ display: "flex", gap: "4px" }}>
                  {activeInGroup.map((k) => (
                    <span
                      key={k}
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #e0d9f8",
                        color: "#271078",
                        borderRadius: "16px",
                        padding: "3px 10px",
                        fontSize: "12px",
                        fontWeight: "700",
                      }}
                    >
                      {formatLabel(k)}: {filters[k]}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <button
          onClick={onClear}
          style={{
            background: "none",
            border: "none",
            color: "#F99E52",
            fontWeight: "700",
            fontSize: "12px",
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          ✕ Clear All
        </button>
      </div>
    </div>
  );
};

export default ReportFilterBanner;
